<template>
  <div>
    <a-form-model :model="form" :colon="false" :rules="formRules" ref="formRef">
      <div class="payment-info" v-if="chosenPaymentMethod?.code === 'CARD'">
        <a-form-model-item prop="cardNumber">
          <template #label>
            <div class="card-label">
              <span class="card-label-text">{{ $t('message.checkout.cardNumber') }}</span>
              <div class="card-logos">
                <img
                  class="card-logo"
                  v-for="(card, cardIndex) in orderDetails.creditCardLogos"
                  :key="cardIndex"
                  :src="displayCardIcon(card)"
                />
              </div>
            </div>
          </template>
          <CardNumber
            :cards="orderDetails.creditCardLogos"
            :value.sync="form.cardNumber"
            @focus="onItemFocus()"
            @blur="onItemBlur('cardNumber', form.cardNumber.length)"
          ></CardNumber>
        </a-form-model-item>
        <a-row :gutter="20">
          <a-col :span="12">
            <a-form-model-item :label="$t('message.checkout.cardName')" prop="cardFirstName">
              <a-input
                v-model="form.cardFirstName"
                :size="size"
                @focus="onItemFocus()"
                @blur="onItemBlur('cardFirstName', form.cardFirstName.length)"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item class="no-required" :label="' '" prop="cardLastName">
              <a-input
                v-model="form.cardLastName"
                :size="size"
                @focus="onItemFocus()"
                @blur="onItemBlur('cardLastName', form.cardLastName.length)"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-form-model-item :label="$t('message.checkout.cvv')" prop="cvv">
          <a-input
            v-model="form.cvv"
            :size="size"
            inputmode="numeric"
            :maxLength="4"
            @input.native="cvvChangeHandler"
            @focus="onItemFocus()"
            @blur="onItemBlur('cvv', form.cvv.length)"
          >
            <template #suffix>
              <img class="cvv-img" src="@/assets/images/checkout/cvv.png" />
            </template>
          </a-input>
        </a-form-model-item>
        <a-form-model-item :label="$t('message.checkout.expiredDate')" prop="expiredDate">
          <a-input
            v-model="form.expiredDate"
            :size="size"
            :maxLength="5"
            placeholder="MM/YY"
            autocomplete="off"
            @input.native="expiredDateChangeHandler"
            @focus="onItemFocus()"
            @blur="onItemBlur('expiredDate', form.expiredDate.length)"
          >
            <template #suffix>
              <img class="expired-date-img" src="@/assets/images/checkout/expired.png" />
            </template>
          </a-input>
        </a-form-model-item>
      </div>
      <!--     bank 子项选择     -->
      <div class="payment-info" v-if="bankList && bankList.length > 0">
        <a-form-model-item :label="$t(getSubSelectMethodBackName(chosenPaymentMethod))" prop="extension.code">
          <a-select
            v-model="form.extension.code"
            :size="size"
            :showSearch="true"
            :optionFilterProp="'label'"
            @change="onBankChange"
            @focus="onItemFocus()"
            @blur="onItemBlur('extension.code', form.extension.code, 'select')"
          >
            <a-select-option v-for="(bank, bankIndex) in bankList" :key="bankIndex" :value="bank.code" :label="bank.name">
              {{ bank.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <div v-for="(item, index) in bankTemplateList" :key="index">
          <a-form-model-item :label="item?.title" :prop="`extension.${item?.param}`">
            <a-input
              v-model="form.extension[item?.param]"
              :size="size"
              @focus="onItemFocus()"
              @blur="onItemBlur(`extension.${item?.param}`, form.extension[item?.param]?.length)"
            />
          </a-form-model-item>
        </div>
      </div>
      <!--     otherOptions 子项选择     -->
      <div v-for="(item, index) in chosenPaymentMethod?.otherOptions" :key="index + item?.code">
        <a-form-model-item :label="item?.name" :prop="`extension.otherOptions.${item?.code}`">
          <a-input
            v-model="form.extension.otherOptions[item?.code]"
            :size="size"
            @focus="onItemFocus()"
            @blur="onItemBlur(`extension.otherOptions.${item?.code}`, form.extension.otherOptions[item?.code]?.length)"
          />
        </a-form-model-item>
      </div>

      <div class="billing-info">
        <div class="billing-title" v-if="isDisplayBillingInfo()">
          {{ $t('message.checkout.billingInfo') }}
        </div>
        <a-row :gutter="20">
          <a-col style="display: none" :span="!displayItems.state ? 0 : 0">
            <a-form-model-item :label="$t('message.checkout.country')" prop="country">
              <CountrySelect
                ref="countrySelect"
                :form="form"
                key-code="country"
                @change="onCountryChange"
                :on-focus="onItemFocus"
                :on-blur="onItemBlur"
              ></CountrySelect>
            </a-form-model-item>
          </a-col>
          <a-col v-if="displayItems.state" :span="!displayItems.country ? 24 : 24">
            <a-form-model-item v-if="stateList && stateList.length !== 0" :label="$t('message.checkout.state')" prop="state">
              <a-select
                v-model="form.state"
                :size="size"
                show-search
                :disabled="stateDisable || disableItems?.state"
                @focus="onItemFocus()"
                @blur="onItemBlur('state', form.state, 'select')"
              >
                <a-select-option v-for="state in stateList" :key="state" :value="state" :label="state" :title="state">
                  {{ state }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item v-else :label="$t('message.checkout.state')" prop="state">
              <a-input
                v-model="form.state"
                :size="size"
                :disabled="disableItems?.state"
                @focus="onItemFocus()"
                @blur="onItemBlur('state', form['state'].length)"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-form-model-item v-if="displayItems.city" :label="$t('message.checkout.city')" prop="city">
          <a-input
            v-model="form.city"
            :size="size"
            @focus="onItemFocus()"
            :disabled="disableItems?.city"
            @blur="onItemBlur('city', form.city.length)"
          />
        </a-form-model-item>
        <a-row :gutter="20">
          <a-col :span="displayItems.streetNumber ? 12 : 24" v-if="displayItems.address">
            <a-form-model-item :label="$t('message.checkout.address')" prop="address">
              <a-input
                v-model="form.address"
                :size="size"
                :disabled="disableItems?.address"
                @focus="onItemFocus()"
                @blur="onItemBlur('address', form.address.length)"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="displayItems.address ? 12 : 24" v-if="displayItems.streetNumber">
            <a-form-model-item :label="$t('message.checkout.streetNumber')" prop="streetNumber">
              <a-input
                v-model="form.streetNumber"
                :size="size"
                :disabled="disableItems?.streetNumber"
                @focus="onItemFocus()"
                @blur="onItemBlur('streetNumber', form.streetNumber.length)"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="20">
          <a-col :span="displayItems.lastName ? 12 : 24" v-if="displayItems.firstName">
            <a-form-model-item :label="$t('message.checkout.firstName')" prop="firstName">
              <a-input
                v-model="form.firstName"
                :size="size"
                :disabled="disableItems?.firstName"
                @focus="onItemFocus()"
                @blur="onItemBlur('firstName', form.firstName.length)"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="displayItems.firstName ? 12 : 24" v-if="displayItems.lastName">
            <a-form-model-item :label="$t('message.checkout.lastName')" prop="lastName">
              <a-input
                v-model="form.lastName"
                :size="size"
                :disabled="disableItems?.lastName"
                @focus="onItemFocus()"
                @blur="onItemBlur('lastName', form.lastName.length)"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-form-model-item
          v-if="displayItems.document && refreshFormItem"
          :label="documentLabel || $t('message.checkout.document')"
          prop="document"
        >
          <a-input
            v-model="form.document"
            :size="size"
            :disabled="disableItems?.document"
            @focus="onItemFocus()"
            @blur="onItemBlur('document', form.document.length)"
          />
        </a-form-model-item>
        <a-form-model-item v-if="displayItems.zipCode" :label="$t('message.checkout.zipCode')" prop="zipCode">
          <a-input
            v-model="form.zipCode"
            :size="size"
            :disabled="disableItems?.zipCode"
            :maxLength="form.country === 'IN' ? 6 : undefined"
            inputmode="numeric"
            @input.native="form.country === 'IN' ? zipCodeChangeHandler($event) : () => {}"
            @focus="onItemFocus()"
            @blur="onItemBlur('zipCode', form.zipCode.length)"
          />
        </a-form-model-item>
        <a-form-model-item v-if="displayItems.email" :label="$t('message.checkout.email')" prop="email">
          <a-input
            v-model="form.email"
            :size="size"
            :disabled="disableItems?.email"
            @focus="onItemFocus()"
            @blur="onItemBlur('email', form.email.length)"
          />
        </a-form-model-item>
        <a-form-model-item v-if="displayItems.phone" :label="$t('message.checkout.phone')" prop="phone">
          <!--          <template v-if="!orderDetails?.billing?.phone">-->
          <a-input-group compact>
            <a-select
              v-model="form.phoneCode"
              :size="size"
              :disabled="disableItems?.phone"
              show-search
              @focus="onItemFocus()"
              @blur="onItemBlur('phoneCode', form.phoneCode, 'select')"
              style="width: 18%"
            >
              <a-select-option v-for="item in phoneCodeList" :key="item" :value="item" :label="item" :title="item">
                {{ item }}
              </a-select-option>
            </a-select>
            <a-input
              v-model="form.phone"
              :size="size"
              :disabled="disableItems?.phone"
              @focus="onItemFocus()"
              @blur="onItemBlur('phone', form.phone.length)"
              style="width: 82%"
            >
            </a-input>
          </a-input-group>
          <!--          </template>-->
          <!--          <template v-else>-->
          <!--            <a-input-->
          <!--              v-model="form.phone"-->
          <!--              :size="size"-->
          <!--              :disabled="disableItems?.phone"-->
          <!--              @focus="onItemFocus()"-->
          <!--              @blur="onItemBlur('phone', form.phone.length)"-->
          <!--            >-->
          <!--            </a-input>-->
          <!--          </template>-->
        </a-form-model-item>
      </div>
    </a-form-model>
  </div>
</template>

<script>
import CardNumber from '@/components/cardnumber'
import { saveOperation } from '@/views/checkout/tools/collect'
import CountrySelect from '@/views/checkout/payment/components/form-content/country/index.vue'
import {
  displayCardIcon,
  documentControl,
  getSubSelectMethodBackName,
  initBankList,
  // getCountryNameText,
  initExtensionRules,
  initPhoneCode,
  initRequiredFields,
  isShowBillingInfo,
  setBillingEditDisplay,
  showDocument,
  stateControl
} from '@/views/checkout/tools'
import { getCheckoutData, initFormData, onExpiredDateInput, onSecurityCodeInput } from '@/utils/tools/checkout'

export default {
  components: {
    CardNumber,
    CountrySelect
  },
  props: {
    orderDetails: {
      type: Object,
      default: () => ({})
    },
    chosenPaymentMethod: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      size: 'large',
      documentLabel: '',
      stateList: [],
      stateDisable: false,
      refreshFormItem: false,
      phoneCodeList: [],
      form: {
        paymentCountry: '',
        cardNumber: '',
        cardFirstName: '',
        cardLastName: '',
        cvv: '',
        expiredDate: '',
        country: '',
        city: '',
        state: '',
        firstName: '',
        lastName: '',
        document: '',
        address: '',
        streetNumber: '',
        zipCode: '',
        email: '',
        phone: '',
        phoneCode: '',
        // 扩展参数
        extension: {}
      },
      formRules: {},
      // 操作收集
      operation: {},
      // 账单信息Item按照逻辑来显示隐藏
      displayItems: {},
      // 账单信息Item按照逻辑是否禁用
      disableItems: {},
      // 本地支付银行列表
      bankList: [],
      // 本地支付银行关联表单模板列表
      bankTemplateList: []
    }
  },
  methods: {
    displayCardIcon,
    getSubSelectMethodBackName,
    onItemFocus() {
      this.operation = {
        code: '',
        type: '',
        focus: new Date().getTime() + '',
        blur: '',
        value: ''
      }
    },
    onItemBlur(code, value, type = 'input') {
      document.body.focus()
      this.operation.value = value
      this.operation.type = type
      this.operation.code = code
      this.operation.blur = new Date().getTime() + ''
      saveOperation(this.operation)
    },
    onBankChange(value) {
      initExtensionRules(this, value)
    },
    expiredDateChangeHandler(evt) {
      this.form.expiredDate = onExpiredDateInput(evt)
    },
    cvvChangeHandler(evt) {
      this.form.cvv = onSecurityCodeInput(evt)
    },
    zipCodeChangeHandler(evt) {
      const value = evt.target.value.replace(/\D/g, '')
      this.form.zipCode = value
    },
    isDisplayBillingInfo() {
      return isShowBillingInfo(this.displayItems)
    },
    onCountryChange(country) {
      if (country === 'IN') {
        this.form.zipCode = ''
      }
      this.documentLabel = showDocument(country)
      stateControl(this, country)
      documentControl(this, country)
    },
    initMethodChild(event) {
      // 切换支付方式时一并清空银行子项的动态表单，避免残留上一个支付方式的表单项
      this.bankTemplateList = []
      // Vue2 无法检测动态添加的属性，extension / otherOptions 上的新 key 必须具备响应式，
      // 否则表单项缓存的 fieldValue 取不到输入值，校验会一直提示 required
      const otherOptions = {}
      ;(event?.otherOptions || []).forEach((item) => {
        otherOptions[item.code] = ''
      })
      this.$set(this.form, 'extension', { code: '', otherOptions })
      // eslint-disable-next-line no-unused-expressions
      this.$refs.formRef?.clearValidate()
    },
    initDisplayDisableItems(event) {
      this.displayItems = {}
      this.disableItems = {}
      if (event.requiredFields) {
        event.requiredFields.forEach((key) => {
          this.displayItems[key] = true
        })
      }
      setBillingEditDisplay(this.orderDetails, this.displayItems, this.disableItems)
    },
    onPaymentMethodChange(event) {
      this.initMethodChild(event)
      this.bankList = initBankList(event, this.form.country)
      initRequiredFields(this, event)
      this.onCountryChange(this.form.country)
      initPhoneCode(this, this.form.country)
      this.initDisplayDisableItems(event)
    },
    // 给账单地址国家赋值
    setAllData(allList, localCountry) {
      if (this.$refs.countrySelect) {
        this.$refs.countrySelect.setAllData(allList, localCountry)
      }
    },
    setFormData(key, value) {
      this.form[key] = value
      if (key === 'country') {
        this.onCountryChange(value)
      }
    },
    getFormData() {
      return getCheckoutData(this.form, this.chosenPaymentMethod)
    },
    verificationForm(successCallback, errorCallback) {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          successCallback(this.getFormData())
        }
      }, errorCallback)
    }
  },
  mounted() {
    initFormData(this.form, this.orderDetails)
    this.onPaymentMethodChange(this.chosenPaymentMethod)
    const count = setTimeout(() => {
      initFormData(this.form, this.orderDetails)
      clearTimeout(count)
    })
  },
  watch: {
    '$props.chosenPaymentMethod': 'onPaymentMethodChange'
  }
}
</script>

<style lang="less" scoped>
@import '~@/styles/common.less';
@import '~@/views/checkout/styles/index.less';

.payment-info {
  .cvv-img {
    width: 45px;
  }

  .expired-date-img {
    width: 45px;
  }

  .card-label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: calc(100% + 12px);

    .card-label-text {
      text-align: left;
      min-width: 130px;
    }

    .card-logos {
      width: clac(100% + 12px);
      margin-left: 8px;
      display: flex;
      gap: 5px;
      overflow: auto;
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none;

      .card-logo {
        max-width: 50px;
        height: 16px;
      }
    }
  }
}

.billing-info {
  .billing-title {
    #Font.heavy();
    font-size: 16px;
    line-height: 22px;
    color: @checkout-text-color;
    padding-bottom: 17px;
  }
}
</style>
